import axios, { encodeData } from "../utils/axios";

export const fetchApplications = async () => {
  const res = await axios.get("/applications").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const fetchApplicationsByAfm = async (afm) => {
  const res = await axios
    .get("/applications/external-user", { params: { afm } })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchApplicationsForPortAuth = async (id) => {
  const res = await axios
    .get("/applications/for-port-auth?pauth_id=" + id)
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });
  // console.log(res.data);
  return res.data;
};

export const fetchCountAllApplicationsKinds = async () => {
  const res = await axios
    .get("/applications/countAllApplicationsKinds")
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchCountAllApplicationsKindsAndStatuses = async () => {
  const res = await axios
    .get("/applications/countAllApplicationsKindsAndStatuses")
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchCountAllApplicationsKindsForPortAuth = async (pid) => {
  const res = await axios
    .get("/applications/countAllApplicationsKindsForPortAuth", {
      params: { pid: pid },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchCountAllApplicationsKindsAndStatusesForPortAuth = async (
  pid
) => {
  const res = await axios
    .get("/applications/countAllApplicationsKindsAndStatusesForPortAuth", {
      params: { pid: pid },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchApplicationsForCitizen = async (id) => {
  const res = await axios
    .get("/applications/for-citizen", { params: { pauth_id: id } })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchFinishedApplications = async (id) => {
  const res = await axios
    .get("/applications/finished", { params: { pauth_id: id } })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchApplicationWithId = async (id) => {
  const res = await axios
    .get("/applications/application?id=" + id)
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchApplicationWithIdExternalUser = async (id) => {
  const res = await axios
    .get("/applications/application/external-user?id=" + id)
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const createApplication = async (newApplication) => {
  await axios.post("/applications/create", encodeData(newApplication));
};

export const rejectSingleApplication = async (rejectApplication) => {
  const res = await axios.post(
    "/applications/reject",
    encodeData(rejectApplication)
  );
  return res;
};

export const createSingleApplication = async (newApplication) => {
  const res = await axios.post(
    "/applications/create-one",
    encodeData(newApplication)
  );
  return res;
};

export const updateApplication = async (updatedApplication) => {
  const res = await axios.put(
    "/applications/update",
    encodeData(updatedApplication)
  );
  return res;
};

export const updateApplicationStatusAndHistory = async (
  updatedApplicationStatusAndHistory
) => {
  const res = await axios.put(
    "/applications/update-application-status-and-history",
    encodeData(updatedApplicationStatusAndHistory)
  );
  return res;
};

export const updateApplicationPortAuth = async (
  updatePortdAuth
) => {
  const res = await axios.put(
    "/applications/updateportauth",
    encodeData(updatePortdAuth)
  );
  return res;
};

export const deleteApplication = async (oldApplication) => {
  await axios.delete("/applications/delete", {
    data: encodeData(oldApplication),
  });
};
